import { useContext } from '@nuxtjs/composition-api'
import { BITRIX_API } from '../../instance'
import { BRAND_MEDIA_ARTICLE } from '../../../../config/bitrix-endpoints'

export async function getArticleShort(
  ctx: ReturnType<useContext> | undefined = undefined,
  code: string
) {
  // Хотелось бы чтобы ради лайков и прочей информации не приходилось получать статью целиком
  const res = await BITRIX_API(ctx).get(`${BRAND_MEDIA_ARTICLE}?code=${code}`)
  const articleData = res.data?.data || {}
  return {
    likes: articleData.likes || 0,
    dislikes: articleData.dislikes || 0,
    neutral: articleData.neutral || 0,
    title: articleData.title,
  }
}
